import React from 'react';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { signInWithRedirect, signOut, fetchAuthSession } from "aws-amplify/auth";
import axios from 'axios';
import { Popconfirm, Spin, Skeleton, Modal, Card, Col, Row, Button, Dropdown, ConfigProvider, theme, Layout } from 'antd';
import { MailOutlined, MoonOutlined, SunOutlined, QuestionCircleOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import Downloader from './Downloader';
// import FreeDownloader from './FreeDownloader';
import Authentication from './Authentication';
import About from './About';
import Help from './components/Help';
import PageBottom from './components/PageBottom';
import GetHelp from './components/GetHelp';
import GetFree from './components/Free';
import NewsFeed from './components/NewsFeed';
import CookieConsent from "react-cookie-consent";

Amplify.configure({
  Auth: {
    Cognito: {
      region: 'eu-west-2',
      userPoolId: 'eu-west-2_CzfZUOkVI',
      userPoolClientId: '2pdp0iaeaod0sn1dh2r6t0maek',
      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      identityPoolId: 'eu-west-2:b07e8f33-6837-4928-9df3-75676a01ee7c',
      // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
      // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
      signUpVerificationMethod: 'code', // 'code' | 'link'
      loginWith: {
        oauth: {
          domain: 'auth.attachmentmanager.com',
          scopes: [
            'email',
            'profile',
            'openid',
            'aws.cognito.signin.user.admin',
            'api/api'
          ],
          redirectSignIn: ['https://attachmentmanager.com/downloader'],
          redirectSignOut: ['https://attachmentmanager.com'],
          // redirectSignIn: ['http://localhost:3000/downloader'],
          // redirectSignOut: ['http://localhost:3000'],
          responseType: 'code' // 'code' or 'token', note that REFRESH token will only be generated when the responseType is code
        }
      }
    }
  }
});

function App() {
  const [currentUserName, setCurrentUserName] = useState(null);
  const [currentUserEmail, setCurrentUserEmail] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [userTheme, setUserTheme] = useState('light');
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [accessToken, setAccessToken] = useState(null);
  // const [showPreview, setShowPreview] = useState(false);

  //popup

  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = () => {
    setConfirmLoading(true);
    var formData = {
      userid: currentUserId,
      email: currentUserEmail,
      sub: 1,
      timestamp: Date.now(),
    }
    console.log(formData);
    try {
      const upRespawait = axios.post('https://api.attachmentmanager.com/workspace/sub', formData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': accessToken,
        },
      });
      console.log(upRespawait);
      setOpen(false);
    } catch (error) {
      console.error('Error:', error.message);
      setOpen(false);
    }
  };

  const handleCancel = () => {
    setConfirmLoading(true);
    var formData = {
      userid: currentUserId,
      email: currentUserEmail,
      sub: 0,
      timestamp: Date.now(),
    }
    console.log(formData);
    try {
      const upRespawait = axios.post('https://api.attachmentmanager.com/workspace/sub', formData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': accessToken,
        },
      });
      console.log(upRespawait);
      setOpen(false);
    } catch (error) {
      console.error('Error:', error.message);
      setOpen(false);
    }
  };

  //get subscription status once we got CurrentUserId value using useEffect 
  useEffect(() => {
    const fetchCurrentUserSubInfo = async () => {
        if (!currentUserId) {
            return; // Exit if currentUserId is null, empty, or not identified
        }

        try {
            const upRespawait = await axios.get(`https://api.attachmentmanager.com/workspace/sub?userid=${currentUserId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': accessToken,
                },
            });

            //console.log("getting sub info", upRespawait.data.sub);

            const currentTimestamp = Date.now(); // Current timestamp in milliseconds
            const oneMonthInMilliseconds = 30 * 24 * 60 * 60 * 1000; // Roughly one month in milliseconds

            //console.log("timestamp", upRespawait.data.timestamp);
            //console.log("threshold", currentTimestamp - oneMonthInMilliseconds);

            if (upRespawait.data.sub == null || upRespawait.data.sub === "" ||
                (upRespawait.data.sub === 0 && upRespawait.data.timestamp < (currentTimestamp - oneMonthInMilliseconds))) {
                setOpen(true);
            }
        } catch (error) {
            console.error(error); // Optional: Log the error for debugging purposes
        } finally {
            setLoading(false);
        }
    };

    fetchCurrentUserSubInfo();
}, [currentUserId, accessToken]);

  const toggleTheme = () => {
    const newTheme = userTheme === 'dark' ? 'light' : 'dark';
    setUserTheme(newTheme);
    localStorage.setItem('userTheme', newTheme);
  };

  useEffect(() => {
    const storedTheme = localStorage.getItem('userTheme');
    if (storedTheme) {
      setUserTheme(storedTheme);
    }
  }, []);

  useEffect(() => {
    const fetchCurrentUserInfo = async () => {
      try {
        const uSession = await fetchAuthSession();
        //const { accessToken, idToken } = uSession.tokens ?? {};
        const { accessToken } = uSession.tokens ?? {};
        setAccessToken(accessToken);
        const token = uSession.tokens.idToken.payload;
        const customCode = token['custom:code'];

        const response = await fetch('https://app.asana.com/api/1.0/users/me', {
          headers: {
            Authorization: `Bearer ${customCode}`
          }
        });
        const userData = await response.json();
        //console.log(userData);
        setCurrentUserName(userData.data.name);
        setCurrentUserEmail(userData.data.email);
        setCurrentUserId(userData.data.gid);


        setLoading(false);
      } catch (error) {
        console.error('Error fetching current user:', error);
        // const uSession = await fetchAuthSession();
        // const uUser = await fetchUserAttributes();
        // console.log("user", uUser);
        // console.log("user session", uSession);
        setCurrentUserName(null);
        setLoading(false);
        handleLogout();
      }
    };
    fetchCurrentUserInfo();
  }, []);

  useEffect(() => {
    // Check if there is an opener window
    if (window.opener) {
      // Send the message
      window.opener.postMessage("success", "https://app.asana.com");
    }
  }, []);

  const handleLogin = async () => {
    try {
      const taskID = new URLSearchParams(window.location.search).get('task');
      const workspaceID = new URLSearchParams(window.location.search).get('workspace');

      if (taskID) {
        sessionStorage.setItem('taskID', taskID); // Store taskID in sessionStorage if not null or empty
        sessionStorage.setItem('workspaceID', workspaceID); // Store taskID in sessionStorage if not null or empty
        //console.log("task id is", sessionStorage.getItem('taskID'));
      }


      const pathname = window.location.pathname;
      if (pathname !== '/start') {
        const action = sessionStorage.getItem('action');
        if (action === 'start') {
          // Redirect to '/start' page
          window.location.href = '/start';
        }
      }

      if (pathname === '/start') {
        sessionStorage.setItem('action', "start");
        window.location.href = '/start'; //add to fix coockie issue, to be tested in cognito/using new user
      }

      // Check if user is trying to open /start page
      // Check sessionStorage for 'action' on page load

      else {

      }

      await signInWithRedirect({ provider: 'Asana' });
    } catch (error) {
      console.error('Error signing in:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const showHelp = () => {
    setModalVisible(true);
  };

  // const showPreviewImage = () => {
  //   setShowPreview(!showPreview);
  //   console.log("show preview", showPreview);
  // };

  const onMenuClick = (e) => {
    if (e.key === '1') {
      toggleTheme();
    } else if (e.key === '2') {
      showHelp();
    } else if (e.key === '3') {
      handleLogout();
    }
  };

  const items = [
    {
      key: '1',
      label: 'Switch Theme',
      icon: userTheme === 'dark' ? <SunOutlined /> : <MoonOutlined />,
    },
    {
      key: '2',
      label: 'Help',
      icon: <QuestionCircleOutlined />,
    },
    {
      key: '3',
      label: 'Logout',
      icon: <LogoutOutlined />,
    }
  ];

  return (
    <>
      <Layout style={{ minHeight: "100vh", margin: 0, padding: 0, backgroundColor: userTheme === 'dark' ? '#1e1f21' : '#f6f8f9' }}>
        <ConfigProvider
          theme={{
            algorithm: userTheme === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
            token: {
              colorPrimary: '#4573D2',
              colorBgBase: userTheme === 'dark' ? '#1e1f21' : '#ffffff',
              colorBgLayout: userTheme === 'dark' ? '#1e1f21' : '#f6f8f9',
              colorLink: userTheme === 'dark' ? '#f5f4f3' : '#4573D2',
              colorText: userTheme === 'dark' ? '#f5f4f3' : '#1e1f21',
              colorTextSecondary: userTheme === 'dark' ? '#a2a0a2' : '#6d6e6f',
              colorBorder: userTheme === 'dark' ? '#3a3a3c' : '#e8e8e8',
              colorBorderSecondary: userTheme === 'dark' ? '#2e2e30' : '#f0f0f0',
              fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
              fontSize: 14,
              borderRadius: 8,
              borderRadiusLG: 12,
              borderRadiusSM: 6,
              boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
              boxShadowSecondary: '0 2px 8px rgba(0,0,0,0.06)',
            },
            components: {
              Card: {
                colorBorderSecondary: userTheme === 'dark' ? '#3a3a3c' : '#edeae9',
                paddingLG: 24,
              },
              Table: {
                headerBg: userTheme === 'dark' ? '#2e2e30' : '#f6f8f9',
                headerColor: userTheme === 'dark' ? '#f5f4f3' : '#6d6e6f',
                fontSize: 13,
                rowHoverBg: userTheme === 'dark' ? '#363638' : '#f9fafb',
              },
              Button: {
                borderRadius: 6,
                controlHeight: 36,
                fontWeight: 500,
              },
              Input: {
                borderRadius: 6,
              },
              Select: {
                borderRadius: 6,
              },
            },
          }}
        >
          <Row justify="center">
            <Col span={24}>
              <Card
                style={{ margin: 0, borderRadius: 0, borderBottom: userTheme === 'dark' ? '1px solid #3a3a3c' : '1px solid #edeae9', boxShadow: 'none' }}
                bordered={false}
                title={<a href="/" style={{ fontSize: 16, fontWeight: 600, color: 'inherit', textDecoration: 'none' }}>Attachment Manager for Asana</a>}
                extra={
                  <>
                    {loading ? (
                      <Spin />
                    ) : (
                      <>
                        {currentUserName ? (
                          <Popconfirm
                            title="Stay Updated!"
                            description={
                              <>
                                <p>Would you like to join our email list to receive the latest product news,
                                  <br />
                                  updates, exclusive webinars, and insightful blog posts?
                                </p>
                              </>
                            }
                            open={open}
                            okText="Yes, sign me up!"
                            cancelText="No, thanks"
                            onConfirm={handleOk}
                            okButtonProps={{ loading: confirmLoading }}
                            onCancel={handleCancel}
                            icon={<MailOutlined />}
                          >
                            <Dropdown.Button menu={{ items, onClick: onMenuClick }}>
                              <UserOutlined />
                              {currentUserName}
                            </Dropdown.Button>
                          </Popconfirm>
                        ) : (
                          <Button onClick={handleLogin}>Login</Button>
                        )}
                      </>
                    )}
                  </>}
              >
                <Router>
                  <Routes>
                    <Route path='/start' element={<Authentication />} />
                    <Route path="/downloader" element={<Downloader />} />
                    {/* <Route path='/freedownloader' element={<FreeDownloader />} /> */}
                    <Route path='/about' element={<About />} />
                    <Route path='/getHelp' element={<GetHelp />} />
                    <Route path='/getFree' element={<GetFree />} />
                    <Route path="/*" element={<About />} />
                  </Routes>
                </Router>
              </Card>
            </Col>
          </Row>
          <NewsFeed />
          {loading ? (
            <Card style={{ marginLeft: 0, marginRight: 0 }} bordered={false}>
              <Skeleton avatar paragraph={{ rows: 4 }} />
            </Card>
          ) : (
            <PageBottom />
          )}
          <Modal
            title="Help"
            open={modalVisible}
            onOk={() => setModalVisible(false)}
            onCancel={() => setModalVisible(false)}>
            <Help />
          </Modal>
        </ConfigProvider >
        <CookieConsent
          location="bottom"
          buttonText="Accept All Cookies"
          declineButtonText="Essential Only"
          enableDeclineButton={true}
          cookieName="attachmentmanager"
          style={{
            background: "rgba(30, 31, 33, 0.97)",
            backdropFilter: "blur(8px)",
            padding: "20px 40px",
            alignItems: "center",
            borderTop: "1px solid rgba(255,255,255,0.1)",
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          }}
          buttonStyle={{
            background: "#4573D2",
            color: "#ffffff",
            fontSize: "14px",
            fontWeight: "500",
            borderRadius: "6px",
            padding: "10px 24px",
            border: "none",
            cursor: "pointer",
          }}
          declineButtonStyle={{
            background: "transparent",
            border: "1px solid rgba(255,255,255,0.3)",
            color: "#ffffff",
            fontSize: "14px",
            fontWeight: "500",
            borderRadius: "6px",
            padding: "10px 24px",
            cursor: "pointer",
          }}
          contentStyle={{
            flex: "1 0 300px",
            margin: "8px 0",
          }}
          expires={200}
        >
          <div style={{ maxWidth: 700 }}>
            <p style={{ fontSize: "15px", fontWeight: "600", margin: "0 0 6px 0", color: "#ffffff" }}>
              Cookie Preferences
            </p>
            <p style={{ fontSize: "13px", lineHeight: "1.5", margin: 0, color: "rgba(255,255,255,0.75)" }}>
              We use cookies to keep you signed in (authentication), remember your preferences
              (theme, image preview) and selected workspace, and to record your cookie consent
              choice. We do not use tracking or advertising cookies.{" "}
              <a href="https://www.bdq.cloud/legal" target="_blank" rel="noopener noreferrer"
                 style={{ color: "#7da2e8", textDecoration: "underline" }}>
                Learn more
              </a>
            </p>
          </div>
        </CookieConsent>
      </Layout >
    </>
  );
}

export default App;